<template>
  <div class="hello">
    <p>{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: '欢迎进入智慧校园,请按正确地址访问！'
    }
  },
  created() {
    console.log('process-----', process.env.NODE_ENV)
  }
}
</script>
<style scoped>
p{
  text-align: center;
  line-height: 100vh;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue